(function() {
  console.log('[Custom Filter] Script started');

  if (typeof selectedSize !== 'undefined' && selectedSize) {
    console.log('[Custom Filter] Final Selected size:', selectedSize);

    // Adjust selectors based on your theme's HTML structure
    document.querySelectorAll('.product-card').forEach(function(card) {
      console.log('[Custom Filter] Processing product card:', card);
      let sizeAvailable = false;

      // Adjust the selector and attributes as per your HTML
      card.querySelectorAll('.variant-option').forEach(function(variant) {
        const size = variant.getAttribute('data-size');
        const inventory = parseInt(variant.getAttribute('data-inventory'), 10);
        console.log('[Custom Filter] Checking variant - Size:', size, 'Inventory:', inventory);

        if (size === selectedSize && inventory > 0) {
          sizeAvailable = true;
          console.log('[Custom Filter] Size available for product:', card);
        }
      });

      if (!sizeAvailable) {
        card.style.display = 'none';
        console.log('[Custom Filter] Hiding product card:', card);
      }
    });
  } else {
    console.log('[Custom Filter] No valid size selected');
  }
})();
